<!-- Main section -->
<div class="profile-text" *ngIf="profileDataResponse?.profileName" id="fTagsProfileTextDiv">
  <div class="profile-name-title" id="profileNameTitleDiv">{{profileNameValue}}</div>
  <h2 class="profile-name-text">{{profileDataResponse?.profileName}}</h2>
</div>
<section class="main_section">
  <div class="main_section_headers" id="fTagsHeadersDiv">
    <img class="fact_tag_header" alt="Create Profile - fact tags display" />
    <span i18n="@@fact-tags.fact-tags-header.facttags">FACT TAGS</span>
  </div>

  <!-- Fact tags body -->
  <div class="pl-1 pr-1" id="fTagsMainDiv">
    <div class="mt-4" id="fTagsBodyDragDrop">
      <span i18n="@@fact-tags.fact-tags-header.drag-and-drop">Drag and drop the rows to reorder fact tags and show or
        hide which fact tags display.</span>
    </div>
    <span class="processor-cant-reorder" i18n="@@fact-tags.fact-tags-header.processor-cant-reorder">”Processor” cannot
      be reordered.</span>
    <div class="mt-3 mb-3" id="fTagsBodyShowOnDevice">
      <span class="show-on-bold" i18n="@@fact-tags.fact-tags-header.show-on-device">Show on Device</span>
    </div>
  </div>

  <!-- Fact-tag selection -->
  <!-- Processor can not be moved. So keep it static -->
  <div class="ftags_list" *ngFor="let factTag of factTags; trackBy: trackByFactTags" id="factTagsListDiv">
    <div class="ftag_selection" *ngIf="factTag?.values?.name === processor" id="factTagsSelection">
      <div class="form-check" [ngbPopover]="popContent" placement="right" triggers="mouseenter:mouseleave" id="factTagsFormCheck">
        <input type="checkbox" class="form-check-input" [checked]="factTag?.show" [disabled]="factTag?.required" />
      </div>
      <div class="ftag_name" id="factTagsName">{{ factTag?.values?.name }}</div>
      <span>
        <img class="facttag_reorder_processor" alt="reorder ftag" />
        <!-- Removed br for GLS purpose -->
        <ng-template #popContent><span i18n="@@fact-tags.fact-tags-header.cant-hidden-reordered">The processor fact tag
            cannot be hidden or reordered.</span></ng-template>
      </span>
    </div>
  </div>
  <!-- All other fact tags can be moved.
    TODO: Use a pipe below to exclude Processor from the items rendered -->
      <div cdkDropList class="ftags_list" (cdkDropListDropped)="dropFactTags($event)" id="factTagsList">
        <div *ngFor="let factTag of factTags; trackBy: trackByFactTags; let i=index" cdkDrag id="fTagsCdkDragDiv">
          <div class="ftag_selection" *ngIf="!factTag?.pin && factTag?.name!='vr'" id="fTagsSelectionDiv">
            <div class="form-check" id="fTagsFrmCheckDiv">
              <input type="checkbox" class="form-check-input" [checked]="factTag?.show" [disabled]="factTag?.required"
                (change)="checkMemory(i, $event, factTag?.values?.name)" />
            </div>
            <div *ngIf="factTag?.values?.type === 'StorePromo'" id="factTagsStorePromo"><img class="star_note_icon" alt="star note"/></div>
            <div class="ftag_name" id="factTagsNameDiv"
              [ngClass]="{'set_padding_left': factTag?.values?.type === 'StorePromo' && factTag?.values?.show_on_device}">
              <div class="promo_pos_label" *ngIf="factTag?.values?.type === 'StorePromo' && factTag?.values?.show_on_device" id="fTagsPromoPosDiv">
                <span>{{ factTag?.position}}</span></div>
              <span [ngClass]="{'set_margin_left': factTag?.values?.type === 'StorePromo' && factTag?.values?.show_on_device}">{{
                factTag?.values?.name }}</span>
              <!-- <div class="ftag_option" *ngIf="factTag?.values?.name === memory" id="factTagsOptionDiv">
                <div class="option_checkbox" id="fTagsCheckboxDiv">
                  <input type="checkbox" [checked]="factTag?.values?.optane_messaging"
                    (change)="checkMemory(i, $event, optaneMemory)" />
                </div>
                <div [ngClass]="{'optaneMemory-hung': isHungarian}" class="optaneMemory" id="fTagsOptaneDiv">{{ optaneMemory }}</div>
              </div> -->
            </div>
            <span>
              <img class="facttag_reorder" alt="reorder ftag"/>
            </span>
          </div>
        </div>
      </div>
      <div class="preview_promos_main_div" *ngIf="isPromoFactTagExist" id="previewPromosMainDiv">
        <div class="preview_promos_div" id="previewPromosChildDiv">
          <img *ngIf="showOnDeviceCount == 0" class="preview_promos_empty" alt="promo postions-empty preview" />
          <img *ngIf="showOnDeviceCount == 1" class="preview_promos_sod1" alt="promo postions-1 preview" />
          <img *ngIf="showOnDeviceCount == 2" class="preview_promos_sod2" alt="promo postions-2 preview" />
          <img *ngIf="showOnDeviceCount == 3" class="preview_promos_sod3" alt="promo postions-3 preview" />
          <div class="preview_promos_label" i18n="@@fact-tags.promo-msg.preview-of-promotional-cont-pos">Preview of Promotional Content Positions</div>
        </div>
        <div class="preview_promos_desc" id="previewPromosDesc">
          <img class="preview_star_note_icon" alt="star note"/>
          <div class="mb-3" id="promosDescDiv1" i18n="@@fact-tags.promotional-cont.show-on-device-promotional-cont-grps">The visibility of any promotional content in IPOS is subject to a user selecting “Show on device”, while adding promotional content groups to the package.</div>
          <div class="mb-3" id="promosDescDiv2" i18n="@@fact-tags.sku-mapping-defined.show-on-device-selection">If there is an SKU mapping defined, then the SKU mapping takes precedence over the “Show on device” selection.</div>
          <div>{{promoPosition}}</div>
        </div>
      </div>


  <div class="button-wrapper justify-content-end" id="fTagsBtnWrapperDiv">
    <button type="button" class="btn btn-outline-primary gtmCreateProfileFactTagSkip"
      (click)="sendToProfile(skip)"><span i18n="@@fact-tags.fact-tags-header.skip">Skip</span></button>
    <button type="button" class="btn btn-primary gtmCreateProfileFactTagSaveAndContinue"
      (click)="sendToProfile(send)"><span class="gtmCreateProfileFactTagSaveAndContinue"
        i18n="@@fact-tags.fact-tags-header.save-and-continue">Save and Continue</span></button>
  </div>
</section>